'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { AnimatedButton } from '@/components/ui/animated-button';
import { EmptyState } from '@/components/ui/empty-state';
import { Clock01Icon } from '@/components/ui/icon/glyphs';
import { Link } from '@/i18n/navigation';
import { ACTIVITY_ICONS, type ActivityFilter } from '../tabs/portfolio-activity-filter';
export function ActivityEmpty(t0) {
  const $ = _c(62);
  const {
    filter
  } = t0;
  const t = useTranslations("profile.next.empty.activity");
  let t1;
  if ($[0] !== t) {
    t1 = t("buys.title");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("buys.body");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = {
      title: t1,
      body: t2
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("sells.title");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("sells.body");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = {
      title: t4,
      body: t5
    };
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("backings.title");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t) {
    t8 = t("backings.body");
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = {
      title: t7,
      body: t8
    };
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t) {
    t10 = t("boosts.title");
    $[21] = t;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t) {
    t11 = t("boosts.body");
    $[23] = t;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t10 || $[26] !== t11) {
    t12 = {
      title: t10,
      body: t11
    };
    $[25] = t10;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t) {
    t13 = t("claims.title");
    $[28] = t;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t) {
    t14 = t("claims.body");
    $[30] = t;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t13 || $[33] !== t14) {
    t15 = {
      title: t13,
      body: t14
    };
    $[32] = t13;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t) {
    t16 = t("gifts.title");
    $[35] = t;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t) {
    t17 = t("gifts.body");
    $[37] = t;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t16 || $[40] !== t17) {
    t18 = {
      title: t16,
      body: t17
    };
    $[39] = t16;
    $[40] = t17;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== t12 || $[43] !== t15 || $[44] !== t18 || $[45] !== t3 || $[46] !== t6 || $[47] !== t9) {
    t19 = {
      buys: t3,
      sells: t6,
      backings: t9,
      boosts: t12,
      claims: t15,
      gifts: t18
    };
    $[42] = t12;
    $[43] = t15;
    $[44] = t18;
    $[45] = t3;
    $[46] = t6;
    $[47] = t9;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  const copy = t19;
  let t20;
  if ($[49] !== copy || $[50] !== filter || $[51] !== t) {
    t20 = filter === undefined ? {
      title: t("title"),
      body: t("body")
    } : copy[filter];
    $[49] = copy;
    $[50] = filter;
    $[51] = t;
    $[52] = t20;
  } else {
    t20 = $[52];
  }
  const selected = t20;
  const t21 = filter === undefined ? Clock01Icon : ACTIVITY_ICONS[filter];
  const t22 = selected.title;
  const t23 = selected.body;
  let t24;
  if ($[53] !== t) {
    t24 = t("cta");
    $[53] = t;
    $[54] = t24;
  } else {
    t24 = $[54];
  }
  let t25;
  if ($[55] !== t24) {
    t25 = <AnimatedButton asChild={true} variant="secondary"><Link href="/markets">{t24}</Link></AnimatedButton>;
    $[55] = t24;
    $[56] = t25;
  } else {
    t25 = $[56];
  }
  let t26;
  if ($[57] !== selected.body || $[58] !== selected.title || $[59] !== t21 || $[60] !== t25) {
    t26 = <EmptyState icon={t21} title={t22} description={t23} action={t25} />;
    $[57] = selected.body;
    $[58] = selected.title;
    $[59] = t21;
    $[60] = t25;
    $[61] = t26;
  } else {
    t26 = $[61];
  }
  return t26;
}